
<template>
    
        <mars-view><mars-view class="tag-layout"><c-filter-tag-layout-item v-for="(option, optionIndex) in options" :key="optionIndex" :index="optionIndex" :text="option.text" :parent-value="option.parentValue" :default-value="option.defaultValue" :type="option.type" :selected-color="primaryColor" :selected="selectedIndex === optionIndex || !!option.defaultValue" :up="selectedIndex === optionIndex" :style="{
                width: 100 / options.length + '%',
            }" @click.native="handleTagLayoutItemTap({
                option,
                optionIndex,
            })"></c-filter-tag-layout-item><slot></slot></mars-view><mars-view v-if="borderBottom" class="border"></mars-view></mars-view>
    
</template>

<script>
import FilterTagLayoutItem from "./FilterTagLayoutItem.vue";
export default {
  components: {
    'c-filter-tag-layout-item': FilterTagLayoutItem
  },
  props: {
    // 选中的项索引
    selectedIndex: {
      type: Number,
      default: -1
    },
    // 数组
    options: Array,
    // 分割线
    borderTop: {
      type: Boolean,
      default: false
    },
    borderBottom: {
      type: Boolean,
      default: true
    },
    // 是否阻止 TouchMove 事件
    preventDefaultTouchMove: {
      type: Boolean,
      default: false
    },
    // 主颜色
    primaryColor: {
      type: String,
      default: '#333'
    }
  },
  data() {
    return {};
  },
  methods: {
    // item 点击
    handleTagLayoutItemTap(obj) {
      obj.lastSelectedIndex = this.selectedIndex;
      this.$emit('taglayouttap', obj);
    }
  }
};
</script>

<style scoped>
.tag-layout-wrapper {
  position: relative;
}
.tag-layout {
  display: flex;
  padding: 15px 17px;
  background-color: #fff;
  box-sizing: border-box;
}
.border {
  border-bottom: 1px solid #f5f5f5;
}

</style>
